module.exports = __webpack_public_path__ + "img/gaizhui.d4b7e361.png";